import { Component, Input, OnInit } from '@angular/core';

import { TwcWizardComponent } from '@topcon/twc-angular';

import { WizardFooterService } from './wizard-footer.service';

/**
 * Component to manage the wizard's footer on a centralized manner
 */
@Component({
    selector: 'cw-wizard-footer',
    templateUrl: 'wizard-footer.component.html',
    standalone: false,
})
export class WizardFooterComponent implements OnInit {
    /** Sets next button as enabled or disabled programmatically */
    @Input() isNextButtonEnabled = true;
    /** Sets close button as visible or hidden programmatically */
    @Input() isCloseButtonVisible = false;
    /** Sets previous button as visible or hidden programmatically */
    @Input() isPrevButtonVisible = true;
    /** Sets previous button as enabled or disabled programmatically */
    @Input() isPrevButtonEnabled = true;
    /** Sets next button as visible or hidden programmatically */
    @Input() isNextButtonVisible = true;
    /** Sets loading button as enabled or disabled programmatically */
    @Input() isLoadingButtonVisible = false;
    /** Sets start of the associated process wizard button as visible or hidden programmatically */
    @Input() isFinishButtonVisible = false;
    /** Sets start of the associated process wizard button as enabled or disabled programmatically */
    @Input() isFinishButtonEnabled = true;
    /** Sets the text that the finish button will show */
    @Input() finishButtonText = 'WIZARD.UPLOAD_AND_PROCESS';
    /** TWC Wizard component associated to the footer. This has to be defined always, so the footer can update the buttons properly */
    @Input() wizard!: TwcWizardComponent;

    constructor(public wizardFooterService: WizardFooterService) {}

    ngOnInit(): void {
        this.wizardFooterService.wizard = this.wizard;
    }
}
